export default "__VITE_ASSET__5780df88__"